import React from 'react';

// Card 1: Guess Player Icon
// Keep the composition focused on the mystery player and one polished football.
export const GuessPlayerIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="guess-player-body" x1="22" y1="18" x2="82" y2="94" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B82F6" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
        <linearGradient id="guess-player-ball" x1="71" y1="65" x2="98" y2="96" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#DBEAFE" />
        </linearGradient>
      </defs>
      <circle cx="53" cy="53" r="43" fill={isDarkMode ? '#17233A' : '#EFF6FF'} />
      <circle cx="51" cy="32" r="17" fill="url(#guess-player-body)" stroke="#1E3A8A" strokeWidth="3" />
      <path
        d="M18 91 C20 66 32 54 51 54 C70 54 82 66 84 91 Z"
        fill="url(#guess-player-body)"
        stroke="#1E3A8A"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <text x="51" y="82" fontSize="29" fontWeight="900" fill="#FFFFFF" textAnchor="middle" fontFamily="Arial, sans-serif">?</text>

      <g>
        <circle cx="84" cy="79" r="17" fill="url(#guess-player-ball)" stroke="#172554" strokeWidth="2.5" />
        <polygon points="84,69 91,74 88,82 80,82 77,74" fill="#172554" />
        <path d="M84 62 L84 69 M98 69 L91 74 M96 88 L88 82 M72 89 L80 82 M70 69 L77 74" fill="none" stroke="#172554" strokeWidth="2.2" strokeLinecap="round" />
      </g>
      <path d="M18 25 L20 30 L25 32 L20 34 L18 39 L16 34 L11 32 L16 30 Z" fill="#60A5FA" />
    </svg>
  </div>
);

// Card 2: Match Vote Icon
export const MatchVoteIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="vote-card" x1="18" y1="15" x2="91" y2="95" gradientUnits="userSpaceOnUse">
          <stop stopColor="#34D399" />
          <stop offset="1" stopColor="#059669" />
        </linearGradient>
      </defs>
      <rect x="15" y="18" width="78" height="75" rx="18" fill={isDarkMode ? '#12362F' : '#ECFDF5'} stroke={isDarkMode ? '#10B981' : '#A7F3D0'} strokeWidth="2" />
      <circle cx="38" cy="45" r="19" fill={isDarkMode ? '#DFF7EF' : '#FFFFFF'} stroke="#064E3B" strokeWidth="2.5" />
      <polygon points="38,34 46,40 43,50 33,50 30,40" fill="#064E3B" />
      <path d="M38 26 L38 34 M55 34 L46 40 M51 58 L43 50 M25 58 L33 50 M21 34 L30 40" fill="none" stroke="#064E3B" strokeWidth="2.2" strokeLinecap="round" />
      <rect x="23" y="72" width="38" height="7" rx="3.5" fill="#A7F3D0" />
      <rect x="23" y="82" width="25" height="5" rx="2.5" fill="#D1FAE5" />
      <circle cx="78" cy="72" r="21" fill="url(#vote-card)" stroke="#047857" strokeWidth="3" />
      <path d="M67 72 L75 80 L90 63" fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M72 22 L76 28 L83 29 L78 34 L79 41 L72 38 L66 41 L67 34 L62 29 L69 28 Z" fill="#FBBF24" />
    </svg>
  </div>
);

// Card 3: Daily Quiz Icon (Matching image.png: Purple clipboard + ? + pencil)
export const DailyQuizIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-18 h-18 sm:w-24 sm:h-24 filter drop-shadow-sm">
      <rect x="22" y="18" width="60" height="78" rx="10" fill="#7C3AED" stroke="#4C1D95" strokeWidth="3" />
      <rect x="28" y="26" width="48" height="64" rx="6" fill={isDarkMode ? '#1E293B' : '#FFFFFF'} />
      <rect x="38" y="10" width="28" height="14" rx="4" fill="#6D28D9" stroke="#4C1D95" strokeWidth="2" />
      <circle cx="52" cy="17" r="3" fill="#FFFFFF" />

      <text x="52" y="60" fontSize="40" fontWeight="900" fill={isDarkMode ? '#C4B5FD' : '#6D28D9'} textAnchor="middle" fontFamily="sans-serif">?</text>

      <g transform="translate(62, 54) rotate(-35)">
        <rect x="0" y="0" width="14" height="38" fill="#9333EA" stroke="#581C87" strokeWidth="2" rx="3" />
        <polygon points="0,38 14,38 7,52" fill="#FDE047" stroke="#581C87" strokeWidth="1.5" />
        <polygon points="4,46 10,46 7,52" fill="#0F172A" />
        <rect x="0" y="-8" width="14" height="8" fill="#F472B6" rx="2" />
      </g>

      <span className="absolute top-2 right-2 text-purple-400 text-xs">✦</span>
    </svg>
  </div>
);

// Card 4: Flag Clash Icon
export const FlagClashIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="flag-clash-blue" x1="20" y1="20" x2="69" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#60A5FA" />
          <stop offset="1" stopColor="#2563EB" />
        </linearGradient>
        <linearGradient id="flag-clash-red" x1="43" y1="20" x2="92" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FB7185" />
          <stop offset="1" stopColor="#E11D48" />
        </linearGradient>
      </defs>
      <circle cx="55" cy="56" r="44" fill={isDarkMode ? '#172033' : '#F8FAFC'} stroke={isDarkMode ? '#475569' : '#E2E8F0'} strokeWidth="2" />
      <path d="M24 91 L85 18" stroke={isDarkMode ? '#94A3B8' : '#334155'} strokeWidth="5" strokeLinecap="round" />
      <path d="M86 91 L25 18" stroke={isDarkMode ? '#94A3B8' : '#334155'} strokeWidth="5" strokeLinecap="round" />
      <circle cx="85" cy="18" r="4" fill="#0F172A" />
      <circle cx="25" cy="18" r="4" fill="#0F172A" />
      <path d="M28 21 C42 15 54 28 70 23 L70 51 C54 56 43 43 37 48 Z" fill="url(#flag-clash-blue)" stroke="#1E40AF" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M82 21 C68 15 56 28 40 23 L40 51 C56 56 67 43 73 48 Z" fill="url(#flag-clash-red)" stroke="#9F1239" strokeWidth="2.5" strokeLinejoin="round" />
      <circle cx="50" cy="34" r="5" fill="#FFFFFF" opacity="0.95" />
      <path d="M62 28 L64 33 L69 34 L65 37 L66 42 L62 39 L58 42 L59 37 L55 34 L60 33 Z" fill="#FFFFFF" />
      <path d="M48 76 L55 69 L62 76 L55 83 Z" fill="#FBBF24" stroke="#B45309" strokeWidth="2" />
    </svg>
  </div>
);

// Card 5: Draw Game Icon
export const DrawGameIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="draw-pencil" x1="75" y1="18" x2="39" y2="81" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FDBA74" />
          <stop offset="0.45" stopColor="#F97316" />
          <stop offset="1" stopColor="#EA580C" />
        </linearGradient>
      </defs>
      <rect x="15" y="18" width="73" height="76" rx="15" fill={isDarkMode ? '#2B211B' : '#FFF7ED'} stroke={isDarkMode ? '#C26B32' : '#FED7AA'} strokeWidth="2.5" />
      <path d="M29 72 C38 61 45 84 57 68 C63 60 68 66 75 60" fill="none" stroke="#FB923C" strokeWidth="4.5" strokeLinecap="round" />
      <g transform="rotate(38 66 45)">
        <rect x="58" y="9" width="17" height="61" rx="5" fill="url(#draw-pencil)" stroke="#9A3412" strokeWidth="2.5" />
        <path d="M58 70 L75 70 L66.5 87 Z" fill="#FFEDD5" stroke="#9A3412" strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M63 80 L70 80 L66.5 87 Z" fill="#1E293B" />
        <rect x="58" y="9" width="17" height="10" rx="4" fill="#FB7185" stroke="#9A3412" strokeWidth="2" />
        <rect x="58" y="18" width="17" height="5" fill="#CBD5E1" />
      </g>
      <path d="M22 27 L24 32 L29 34 L24 36 L22 41 L20 36 L15 34 L20 32 Z" fill="#FDBA74" />
    </svg>
  </div>
);

// Card 6: Infinity Craft — an infinity loop built from sports colours and balls.
export const InfinityCraftIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="infinity-craft-loop" x1="17" y1="28" x2="93" y2="82" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2563EB" />
          <stop offset="0.48" stopColor="#7C3AED" />
          <stop offset="1" stopColor="#EC4899" />
        </linearGradient>
      </defs>
      <circle cx="55" cy="55" r="46" fill={isDarkMode ? '#172033' : '#F5F3FF'} />
      <path
        d="M19 57 C19 38 39 32 54 51 L60 59 C74 78 92 70 92 54 C92 38 73 32 59 51 L51 61 C37 79 19 72 19 57 Z"
        fill="none"
        stroke="url(#infinity-craft-loop)"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="38" r="10" fill="#FFFFFF" stroke="#1E3A8A" strokeWidth="2" />
      <path d="M24 32 L29 36 L27 42 L21 42 L19 36 Z" fill="#1E3A8A" />
      <path d="M15 38 L20 36 M29 36 L33 37 M21 42 L19 47 M27 42 L30 47" stroke="#1E3A8A" strokeWidth="1.4" />
      <circle cx="86" cy="72" r="10" fill="#F97316" stroke="#9A3412" strokeWidth="2" />
      <path d="M77 72 H95 M86 63 V81 M79 66 C84 70 84 75 79 78 M93 66 C88 70 88 75 93 78" fill="none" stroke="#9A3412" strokeWidth="1.4" />
      <path d="M78 22 L80 27 L85 29 L80 31 L78 36 L76 31 L71 29 L76 27 Z" fill="#FBBF24" />
    </svg>
  </div>
);

// Card 7: Sports Games Icon
export const SportsGamesIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="sports-games-pad" x1="18" y1="25" x2="92" y2="91" gradientUnits="userSpaceOnUse">
          <stop stopColor="#60A5FA" />
          <stop offset="0.5" stopColor="#2563EB" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      <circle cx="55" cy="55" r="45" fill={isDarkMode ? '#17233A' : '#EFF6FF'} />
      <path
        d="M28 29 C17 29 11 39 9 58 C7 77 17 89 30 89 C39 89 44 79 55 79 C66 79 71 89 80 89 C93 89 103 77 101 58 C99 39 93 29 82 29 Z"
        fill="url(#sports-games-pad)"
        stroke="#1E3A8A"
        strokeWidth="3.5"
        strokeLinejoin="round"
      />
      <path d="M18 54 C22 39 26 36 35 36 L75 36 C84 36 88 39 92 54" fill="none" stroke="#93C5FD" strokeWidth="3" strokeLinecap="round" opacity="0.8" />
      <rect x="26" y="47" width="8" height="23" rx="3" fill="#FFFFFF" />
      <rect x="18.5" y="54.5" width="23" height="8" rx="3" fill="#FFFFFF" />
      <circle cx="82" cy="50" r="5" fill="#FBBF24" stroke="#92400E" strokeWidth="1.5" />
      <circle cx="91" cy="61" r="5" fill="#FB7185" stroke="#9F1239" strokeWidth="1.5" />
      <circle cx="54" cy="59" r="11" fill="#FFFFFF" stroke="#172554" strokeWidth="2" />
      <polygon points="54,52 59,56 57,62 51,62 49,56" fill="#172554" />
      <path d="M54 48 L54 52 M64 52 L59 56 M62 67 L57 62 M46 67 L51 62 M44 52 L49 56" fill="none" stroke="#172554" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M18 24 L20 29 L25 31 L20 33 L18 38 L16 33 L11 31 L16 29 Z" fill="#60A5FA" />
    </svg>
  </div>
);

// Card 8: Sports Market Icon
export const SportsMarketIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-[76px] h-[76px] sm:w-24 sm:h-24 filter drop-shadow-sm" aria-hidden="true">
      <defs>
        <linearGradient id="market-cart" x1="21" y1="37" x2="90" y2="82" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FDBA74" />
          <stop offset="1" stopColor="#F97316" />
        </linearGradient>
      </defs>
      <circle cx="57" cy="54" r="45" fill={isDarkMode ? '#2B211B' : '#FFF7ED'} />
      <path
        d="M14 27 H25 L37 70 H87 L96 39 H31"
        fill="url(#market-cart)"
        fillOpacity="0.25"
        stroke="#C2410C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M38 70 H88" stroke="#C2410C" strokeWidth="4" strokeLinecap="round" />
      <circle cx="45" cy="84" r="7" fill="#7C2D12" />
      <circle cx="81" cy="84" r="7" fill="#7C2D12" />
      <circle cx="45" cy="84" r="3" fill="#FDBA74" />
      <circle cx="81" cy="84" r="3" fill="#FDBA74" />

      <g>
        <circle cx="49" cy="43" r="15" fill="#FB923C" stroke="#9A3412" strokeWidth="2.3" />
        <path d="M34 43 H64 M49 28 V58 M39 31 C47 38 47 48 39 55 M59 31 C51 38 51 48 59 55" fill="none" stroke="#9A3412" strokeWidth="1.8" />
      </g>
      <g>
        <circle cx="76" cy="46" r="14" fill="#FFFFFF" stroke="#172554" strokeWidth="2.3" />
        <polygon points="76,37 82,41 80,49 72,49 70,41" fill="#172554" />
        <path d="M76 32 L76 37 M88 36 L82 41 M87 55 L80 49 M65 55 L72 49 M64 36 L70 41" fill="none" stroke="#172554" strokeWidth="1.9" strokeLinecap="round" />
      </g>
      <path d="M88 19 L90 24 L95 26 L90 28 L88 33 L86 28 L81 26 L86 24 Z" fill="#F59E0B" />
    </svg>
  </div>
);

// Card 9: Sales Simulator Icon (Matching image.png: Green 3D Bar chart + $ Dollar coin)
export const SalesSimulatorIconNew = () => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-18 h-18 sm:w-24 sm:h-24 filter drop-shadow-sm">
      <rect x="14" y="70" width="14" height="24" rx="4" fill="#22C55E" stroke="#15803D" strokeWidth="2.5" />
      <rect x="34" y="52" width="14" height="42" rx="4" fill="#22C55E" stroke="#15803D" strokeWidth="2.5" />

      <path
        d="M10 54 L58 14 L58 30 M58 14 L42 14"
        fill="none"
        stroke="#16A34A"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <circle cx="74" cy="66" r="23" fill="#10B981" stroke="#047857" strokeWidth="3.5" />
      <text x="74" y="75" fontSize="28" fontWeight="900" fill="#FFFFFF" textAnchor="middle" fontFamily="sans-serif">$</text>

      <span className="absolute top-1 left-2 text-emerald-400 text-xs">✦</span>
    </svg>
  </div>
);

// Card 10: Player Review Icon (Matching image.png: Red Bust + 3D Red Star)
export const PlayerReviewIconNew = () => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-18 h-18 sm:w-24 sm:h-24 filter drop-shadow-sm">
      <circle cx="48" cy="38" r="20" fill="#F43F5E" stroke="#9F1239" strokeWidth="3" />
      <path d="M18 88 C18 66 30 60 48 60 C66 60 78 66 78 88 Z" fill="#F43F5E" stroke="#9F1239" strokeWidth="3" />

      <polygon
        points="84,48 90,62 104,64 94,75 96,89 84,82 72,89 74,75 64,64 78,62"
        fill="#EF4444"
        stroke="#BE123C"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />

      <span className="absolute top-1 right-2 text-rose-400 text-xs">✦</span>
    </svg>
  </div>
);

// Card 11: On This Day Icon (Matching image.png: Flip Calendar + Soccer ball)
export const OnThisDayIconNew = ({ isDarkMode = false }) => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-18 h-18 sm:w-24 sm:h-24 filter drop-shadow-sm">
      <rect x="22" y="24" width="66" height="72" rx="10" fill={isDarkMode ? '#1E293B' : '#FFFFFF'} stroke={isDarkMode ? '#D97706' : '#451A03'} strokeWidth="3.5" />
      <path d="M22 30 C22 26 26 22 30 22 L80 22 C84 22 88 26 88 30 L88 40 L22 40 Z" fill="#78350F" />
      <rect x="34" y="12" width="7" height="16" rx="3" fill="#451A03" />
      <rect x="68" y="12" width="7" height="16" rx="3" fill="#451A03" />

      <g transform="translate(55, 68) scale(0.9)">
        <circle cx="0" cy="0" r="18" fill="#FFFFFF" stroke="#0F172A" strokeWidth="3" />
        <polygon points="0,-12 8,-6 5,4 -5,4 -8,-6" fill="#0F172A" />
        <line x1="0" y1="-12" x2="0" y2="-18" stroke="#0F172A" strokeWidth="2.5" />
        <line x1="8" y1="-6" x2="14" y2="-10" stroke="#0F172A" strokeWidth="2.5" />
        <line x1="5" y1="4" x2="11" y2="10" stroke="#0F172A" strokeWidth="2.5" />
        <line x1="-5" y1="4" x2="-11" y2="10" stroke="#0F172A" strokeWidth="2.5" />
        <line x1="-8" y1="-6" x2="-14" y2="-10" stroke="#0F172A" strokeWidth="2.5" />
      </g>

      <span className="absolute top-2 left-2 text-amber-500 text-xs">✦</span>
    </svg>
  </div>
);

// Card 12: Fun Dilemma Icon (Matching image.png: Yellow Happy Mask & Blue Sad Mask + ?)
export const FunDilemmaIconNew = () => (
  <div className="relative w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center">
    <svg viewBox="0 0 110 110" className="w-18 h-18 sm:w-24 sm:h-24 filter drop-shadow-sm">
      <g transform="translate(28, 52) rotate(-12)">
        <path d="M-20,-26 C-20,-32 20,-32 20,-26 L20,14 C20,26 -20,26 -20,14 Z" fill="#FACC15" stroke="#854D0E" strokeWidth="3" />
        <path d="M-12,-12 Q-7,-18 -2,-12" fill="none" stroke="#78350F" strokeWidth="3" strokeLinecap="round" />
        <path d="M2,-12 Q7,-18 12,-12" fill="none" stroke="#78350F" strokeWidth="3" strokeLinecap="round" />
        <path d="M-12,2 Q0,16 12,2 Z" fill="#78350F" />
      </g>

      <g transform="translate(74, 60) rotate(12)">
        <path d="M-20,-26 C-20,-32 20,-32 20,-26 L20,14 C20,26 -20,26 -20,14 Z" fill="#2563EB" stroke="#1E40AF" strokeWidth="3" />
        <ellipse cx="-8" cy="-10" rx="3.5" ry="4.5" fill="#0F172A" />
        <ellipse cx="8" cy="-10" rx="3.5" ry="4.5" fill="#0F172A" />
        <path d="M-12,10 Q0,0 12,10" fill="none" stroke="#0F172A" strokeWidth="3.5" strokeLinecap="round" />
      </g>

      <text x="90" y="24" fontSize="22" fontWeight="900" fill="#EF4444" fontFamily="sans-serif">?</text>
      <text x="98" y="32" fontSize="16" fontWeight="900" fill="#EF4444" fontFamily="sans-serif">?</text>

      <span className="absolute top-1 left-2 text-yellow-400 text-xs">✦</span>
    </svg>
  </div>
);

// Floating Sports Illustrations for Hero Banner (Responsively positioned on Mobile & Desktop so text is NEVER overlapped!)
export const FloatingSportsBalls = ({ isDarkMode = false }) => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden z-0" aria-hidden="true">
    {/* Soccer Ball Top Right */}
    <g className="absolute bottom-1 left-[14%] sm:bottom-auto sm:top-4 sm:left-auto sm:right-[14%] w-6 h-6 sm:w-14 sm:h-14 opacity-80 sm:opacity-90 animate-bounce" style={{ animationDuration: '3s' }}>
      <svg viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="22" fill={isDarkMode ? '#CBD5E1' : '#FFFFFF'} stroke="#1E293B" strokeWidth="3" />
        <polygon points="25,10 35,17 31,30 19,30 15,17" fill="#1E293B" />
        <line x1="25" y1="10" x2="25" y2="3" stroke="#1E293B" strokeWidth="2" />
        <line x1="35" y1="17" x2="43" y2="12" stroke="#1E293B" strokeWidth="2" />
        <line x1="31" y1="30" x2="38" y2="37" stroke="#1E293B" strokeWidth="2" />
        <line x1="19" y1="30" x2="12" y2="37" stroke="#1E293B" strokeWidth="2" />
        <line x1="15" y1="17" x2="7" y2="12" stroke="#1E293B" strokeWidth="2" />
      </svg>
    </g>

    {/* Basketball Top Far Right */}
    <g className="absolute bottom-2 left-[33%] sm:bottom-auto sm:top-12 sm:left-auto sm:right-[4%] w-5 h-5 sm:w-12 sm:h-12 opacity-80 sm:opacity-85 animate-float">
      <svg viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="22" fill="#F97316" stroke="#9A3412" strokeWidth="3" />
        <line x1="3" y1="25" x2="47" y2="25" stroke="#9A3412" strokeWidth="2" />
        <line x1="25" y1="3" x2="25" y2="47" stroke="#9A3412" strokeWidth="2" />
        <path d="M8,10 Q25,25 8,40" fill="none" stroke="#9A3412" strokeWidth="2" />
        <path d="M42,10 Q25,25 42,40" fill="none" stroke="#9A3412" strokeWidth="2" />
      </svg>
    </g>

    {/* Cricket Bat & Ball beside the hero copy */}
    <g className="absolute bottom-0 left-1/2 -translate-x-1/2 sm:bottom-auto sm:top-28 sm:left-auto sm:translate-x-0 sm:right-[25%] rotate-[-18deg] w-7 h-7 sm:w-14 sm:h-14 opacity-75 sm:opacity-90 animate-pulse">
      <svg viewBox="0 0 60 60">
        <rect x="25" y="15" width="12" height="35" rx="3" fill="#D97706" stroke="#78350F" strokeWidth="2" />
        <rect x="28" y="2" width="6" height="15" fill="#FDE047" stroke="#78350F" strokeWidth="2" />
        <circle cx="48" cy="42" r="7" fill="#DC2626" stroke="#991B1B" strokeWidth="1.5" />
      </svg>
    </g>

    {/* Tennis Ball Bottom Right */}
    <g className="absolute bottom-2 left-[70%] sm:bottom-auto sm:top-36 sm:left-auto sm:right-[18%] w-5 h-5 sm:w-10 sm:h-10 opacity-80 sm:opacity-90 animate-bounce" style={{ animationDuration: '3.6s' }}>
      <svg viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="18" fill="#A3E635" stroke="#4D7C0F" strokeWidth="2" />
        <path d="M5,12 Q20,20 5,28" fill="none" stroke="#FFFFFF" strokeWidth="2.5" />
        <path d="M35,12 Q20,20 35,28" fill="none" stroke="#FFFFFF" strokeWidth="2.5" />
      </svg>
    </g>

    {/* Volleyball Middle Right */}
    <g className="hidden sm:block absolute top-32 right-[8%] w-11 h-11 opacity-85">
      <svg viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="18" fill={isDarkMode ? '#CBD5E1' : '#FFFFFF'} stroke="#334155" strokeWidth="2" />
        <path d="M6 14 C16 10 24 10 34 14" fill="none" stroke="#334155" strokeWidth="1.5" />
        <path d="M6 26 C16 30 24 30 34 26" fill="none" stroke="#334155" strokeWidth="1.5" />
        <path d="M14 6 C10 16 10 24 14 34" fill="none" stroke="#334155" strokeWidth="1.5" />
      </svg>
    </g>

    {/* Floating Sparkles */}
    <span className="hidden sm:inline absolute top-2 right-[22%] text-blue-400 text-sm animate-pulse">✦</span>
    <span className="hidden sm:inline absolute top-14 right-[12%] text-indigo-400 text-xs animate-ping">✦</span>
    <span className="hidden sm:inline absolute bottom-2 right-[2%] text-sky-400 text-xs">✦</span>
  </div>
);

// Suggestion Lightbulb Icon matching image.png
export const SuggestionBulbIcon = () => (
  <div className="relative w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center flex-shrink-0">
    <svg viewBox="0 0 60 60" className="w-9 h-9 sm:w-12 sm:h-12 drop-shadow-sm">
      <path d="M30 6 C18 6 10 15 10 27 C10 34 14 40 19 44 L19 49 L41 49 L41 44 C46 40 50 34 50 27 C50 15 42 6 30 6 Z" fill="#FBBF24" stroke="#F59E0B" strokeWidth="2" />
      <path d="M30 10 C22 10 15 17 15 26 C15 31 18 36 22 39 L22 43 L38 43 L38 39 C42 36 45 31 45 26 C45 17 38 10 30 10 Z" fill="#F59E0B" opacity="0.4" />
      <path d="M26 44 L26 30 C26 26 34 26 34 30 L34 44" fill="none" stroke="#EA580C" strokeWidth="2.5" strokeLinecap="round" />
      <rect x="21" y="49" width="18" height="5" fill="#64748B" rx="1.5" />
      <rect x="23" y="54" width="14" height="4" fill="#475569" rx="1.5" />
      <line x1="30" y1="0" x2="30" y2="3" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
      <line x1="8" y1="8" x2="12" y2="12" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
      <line x1="52" y1="8" x2="48" y2="12" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
      <line x1="0" y1="27" x2="4" y2="27" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
      <line x1="60" y1="27" x2="56" y2="27" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
    </svg>
  </div>
);

// Footer Trophy Icon matching image.png
export const FooterTrophyIcon = () => (
  <div className="relative w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center flex-shrink-0">
    <svg viewBox="0 0 60 60" className="w-10 h-10 sm:w-14 sm:h-14 drop-shadow-sm">
      <circle cx="6" cy="18" r="1.5" fill="#3B82F6" />
      <polygon points="8,26 10,30 14,32 10,34 8,38 6,34 2,32 6,30" fill="#3B82F6" />
      <polygon points="52,14 54,18 58,20 54,22 52,26 50,22 46,20 50,18" fill="#3B82F6" />
      <circle cx="54" cy="34" r="1.5" fill="#F97316" />

      <path d="M15 10 L45 10 L45 30 C45 40 37 46 30 46 C23 46 15 40 15 30 Z" fill="#F59E0B" stroke="#D97706" strokeWidth="2" />
      <path d="M19 13 L41 13 L41 29 C41 36 35 42 30 42 C25 42 19 36 19 29 Z" fill="#FBBF24" />
      <path d="M30 28 C28 23 22 23 22 27 C22 31 30 36 30 36 C30 36 38 31 38 27 C38 23 32 23 30 28 Z" fill="#FFFFFF" />

      <path d="M15 15 C8 15 8 27 15 27" fill="none" stroke="#D97706" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M45 15 C52 15 52 27 45 27" fill="none" stroke="#D97706" strokeWidth="3.5" strokeLinecap="round" />

      <rect x="26" y="46" width="8" height="6" fill="#D97706" />
      <rect x="17" y="52" width="26" height="5" fill="#B45309" rx="2" />
      <rect x="20" y="53" width="20" height="3" fill="#F59E0B" rx="1" />
    </svg>
  </div>
);

// High-resolution vector SVGs for 8 Sports Balls in Footer
export const FooterSportsBallsRow = () => (
  <div className="flex items-center justify-center sm:justify-start gap-2 sm:gap-3 mt-2 flex-wrap">
    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <circle cx="16" cy="16" r="14" fill="#FFFFFF" stroke="#1E293B" strokeWidth="2" />
        <polygon points="16,8 21,12 19,18 13,18 11,12" fill="#1E293B" />
        <line x1="16" y1="8" x2="16" y2="2" stroke="#1E293B" strokeWidth="1.5" />
        <line x1="21" y1="12" x2="26" y2="9" stroke="#1E293B" strokeWidth="1.5" />
        <line x1="19" y1="18" x2="24" y2="23" stroke="#1E293B" strokeWidth="1.5" />
        <line x1="13" y1="18" x2="8" y2="23" stroke="#1E293B" strokeWidth="1.5" />
        <line x1="11" y1="12" x2="6" y2="9" stroke="#1E293B" strokeWidth="1.5" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <circle cx="16" cy="16" r="14" fill="#F97316" stroke="#C2410C" strokeWidth="2" />
        <line x1="2" y1="16" x2="30" y2="16" stroke="#7C2D12" strokeWidth="1.5" />
        <line x1="16" y1="2" x2="16" y2="30" stroke="#7C2D12" strokeWidth="1.5" />
        <path d="M6,7 Q16,16 6,25" fill="none" stroke="#7C2D12" strokeWidth="1.5" />
        <path d="M26,7 Q16,16 26,25" fill="none" stroke="#7C2D12" strokeWidth="1.5" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <circle cx="16" cy="16" r="14" fill="#DC2626" stroke="#991B1B" strokeWidth="2" />
        <path d="M7,7 Q16,16 25,25" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeDasharray="2 2" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <circle cx="16" cy="16" r="14" fill="#CCFF00" stroke="#84CC16" strokeWidth="2" />
        <path d="M4,10 Q16,16 4,22" fill="none" stroke="#FFFFFF" strokeWidth="2" />
        <path d="M28,10 Q16,16 28,22" fill="none" stroke="#FFFFFF" strokeWidth="2" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <circle cx="16" cy="16" r="14" fill="#FFFFFF" stroke="#94A3B8" strokeWidth="2" />
        <path d="M8,6 Q16,16 8,26" fill="none" stroke="#EF4444" strokeWidth="2" strokeDasharray="2 2" />
        <path d="M24,6 Q16,16 24,26" fill="none" stroke="#EF4444" strokeWidth="2" strokeDasharray="2 2" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <circle cx="16" cy="16" r="14" fill="#FFFFFF" stroke="#2563EB" strokeWidth="2" />
        <path d="M5,11 Q16,8 27,11" fill="none" stroke="#2563EB" strokeWidth="1.5" />
        <path d="M5,21 Q16,24 27,21" fill="none" stroke="#2563EB" strokeWidth="1.5" />
        <path d="M11,5 Q8,16 11,27" fill="none" stroke="#2563EB" strokeWidth="1.5" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 transform rotate-[-30deg] drop-shadow-sm">
        <ellipse cx="16" cy="16" rx="14" ry="9" fill="#9A3412" stroke="#7C2D12" strokeWidth="2" />
        <line x1="8" y1="16" x2="24" y2="16" stroke="#FFFFFF" strokeWidth="2" />
        <line x1="12" y1="13" x2="12" y2="19" stroke="#FFFFFF" strokeWidth="1.5" />
        <line x1="16" y1="13" x2="16" y2="19" stroke="#FFFFFF" strokeWidth="1.5" />
        <line x1="20" y1="13" x2="20" y2="19" stroke="#FFFFFF" strokeWidth="1.5" />
      </svg>
    </div>

    <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
      <svg viewBox="0 0 32 32" className="w-5 h-5 sm:w-6 sm:h-6 drop-shadow-sm">
        <path d="M22,4 L14,24 L6,26 L6,28 L16,28 L24,4 Z" fill="#78350F" />
        <ellipse cx="22" cy="26" rx="5" ry="2.5" fill="#1E293B" />
      </svg>
    </div>
  </div>
);
